import { SET_MAP_SWITCHER_STATE } from '../constants';
import { getInitialState } from './initialState';
export const mapSwitcher = (state = getInitialState(), action) => {
    switch (action.type) {
        case SET_MAP_SWITCHER_STATE: {
            return action.payload;
        }
        default: {
            return state;
        }
    }
};
//# sourceMappingURL=mapSwitcherReducer.js.map